__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@top/dashboard";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@mui/icons-material", "5.15.18", () => (Promise.all([__webpack_require__.e(3934), __webpack_require__.e(4326), __webpack_require__.e(957), __webpack_require__.e(7776)]).then(() => (() => (__webpack_require__(64326))))));
			register("@mui/material", "5.15.18", () => (Promise.all([__webpack_require__.e(3549), __webpack_require__.e(3758), __webpack_require__.e(606), __webpack_require__.e(1103), __webpack_require__.e(4166), __webpack_require__.e(3934), __webpack_require__.e(4285), __webpack_require__.e(2558), __webpack_require__.e(5668), __webpack_require__.e(8671), __webpack_require__.e(5696), __webpack_require__.e(1088), __webpack_require__.e(3503), __webpack_require__.e(3007), __webpack_require__.e(4444), __webpack_require__.e(957), __webpack_require__.e(2151)]).then(() => (() => (__webpack_require__(44444))))));
			register("@mui/styles", "5.15.18", () => (Promise.all([__webpack_require__.e(4165), __webpack_require__.e(957), __webpack_require__.e(4267)]).then(() => (() => (__webpack_require__(55417))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(3144), __webpack_require__.e(957), __webpack_require__.e(1513)]).then(() => (() => (__webpack_require__(43144))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(647), __webpack_require__.e(957), __webpack_require__.e(7585)]).then(() => (() => (__webpack_require__(20647))))));
			register("react", "17.0.2", () => (__webpack_require__.e(4041).then(() => (() => (__webpack_require__(14041))))));
			initExternal(79729);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};